import React, { useEffect } from 'react';
import { FormField, OwnerInterface } from '../types'
import { useRef, useState } from 'react';
import { useOutsideAlerter } from '../useOutsideAlerter';
import Spinner from '../documentation/Spinner';
import useApi from '../api';
import { set } from 'lodash';
import Consumer from '../Consumer';
import FieldSelect from '../ui/FieldSelect';
import { ToastContainer, toast, ToastOptions } from 'react-toastify';
import toastConfig from '../config/Toast';
import MarkdownEditor from '../ui/MarkdownEditor';
import ContentEditor from '../ui/editor/ContentEditor';


interface ContentProps {
    docId: string | undefined;
    contentId: string | undefined;
    fields: FormField[];
    modalRef: any;
    toggleModal: any
    setContents: any
    modalVisible: boolean
}

const CreateContent: React.FC<ContentProps> = ({ docId, contentId, fields, modalRef, toggleModal, setContents, modalVisible }) => {
    const [contextDocs, setContextDocs] = useState<any[]>([]);
    const [contId, setContId] = useState<string | undefined>(contentId);
    const [content, setContent] = useState<string | undefined>('');
    const [contentName, setContentName] = useState<string>('');
    const [contentDescription, setContentDescription] = useState<string>('');
    const [userInput, setUserInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [consumers, setConsumers] = useState<OwnerInterface[]>([]);
    const [selectedFields, setSelectedFields] = useState<FormField[]>([]);
    const [assistantResponse, setAssistantResponse] = useState('');
    const [editDescription, setEditDescription] = useState(false);
    const [editName, setEditName] = useState(false);
    const { get, getStream, post, postStream, put, patch, remove } = useApi();

    return (
        <ContentEditor docId={docId} contentId={contentId} fields={fields} modalRef={modalRef} toggleModal={toggleModal} setContents={setContents} modalVisible={modalVisible} />
    );
};

export default CreateContent;
